import { render, staticRenderFns } from "./PoliciesShowIndex.vue?vue&type=template&id=d1cabd84&scoped=true&"
import script from "./PoliciesShowIndex.vue?vue&type=script&lang=js&"
export * from "./PoliciesShowIndex.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesShowIndex.vue?vue&type=style&index=0&id=d1cabd84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cabd84",
  null
  
)

export default component.exports